<template>
  <b-form class="invoice-search-form mb-3" @submit.prevent>
    <b-input-group size="lg">
      <b-input-group-prepend>
        <b-input-group-text class="bg-secondary text-white">
          <b-icon-search class="search-icon" font-scale="0.8" />
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        :placeholder="$t('searchForm.placeholder')"
        @input="debounceSearch"
        :value="value"
      />
      <a href="#" class="clear-link" @click.prevent="clear" v-if="value !== ''">
        <b-icon-x class="clear-icon" />
      </a>
    </b-input-group>
  </b-form>
</template>
<script>
import debounce from 'lodash/debounce'

export default {
  props: ['value'],
  methods: {
    clear() {
      this.$emit('input', '')
    },
    debounceSearch: debounce(function (val) {
      this.$emit('input', val)
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.invoice-search-form {
  position: relative;
  box-shadow: $drip-card-shadow;
  outline: 0;

  .form-control {
    height: 3.6rem;
    font-size: 1rem;

    &:focus {
      outline: 0;
      box-shadow: none;
      border-color: $gray-400;
    }
  }
  .input-group-text {
    width: 54px;
    text-align: center;
  }
}

.search-icon {
  margin: auto;
}

.clear-link {
  position: absolute;
  cursor: pointer;
  right: 0;
  height: 100%;
  width: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  z-index: 3;
  background: transparent;
}

.clear-icon {
  width: 2rem;
  height: 2rem;
}
</style>
